var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status === 'FINISHED')?_c('b-icon-check2',{attrs:{"font-scale":"1.5"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }